import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovDatasetProps,
    LoadMarkovDatasetById,
    setMarkovDatasetEdit,
    setMarkovDatasetReloadEdit,
    initMarkovDataset,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    datasetId = null,
}: MarkovDatasetProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const dataset = useSelector((state: StoreType) => state.markovDataset.datasetEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovDataset.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovDatasetReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovDatasetReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (datasetId === 0) {
            dispatch(setMarkovDatasetEdit(initMarkovDataset))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovDatasetById(datasetId, model.id).then((res) => {
                dispatch(setMarkovDatasetEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!dataset) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{dataset.id ? `${lang.editDataset} # ${dataset.id}` : lang.addDataset}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form dataset={dataset} />
                }
                {
                    reloadEdit
                    && <Form dataset={dataset} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
